import AppAdapter from 'adapters/app';

class LicenseAdapter extends AppAdapter {
  constructor(props) {
    super(props)
  }

	static userId = '';
	static providerId = '';
}

export default LicenseAdapter;